import { cloneDeep } from 'lodash'

export const cleanFlow = (flow: APIFlow): FlowUpdate => {
  const copy = cloneDeep(flow)
  delete copy.id
  if (copy.description?.length === 0) {
    copy.description = null
  }
  return copy
}
